import { Box, styled } from '@mui/material';

import { Colors } from 'Themes/colors';
import { Spacing } from 'Themes/spacing';

export const Divider = styled(Box)`
  width: 1px;
  background: ${Colors.lightGrey};
  margin: 0 ${Spacing.large};
  align-self: stretch;
`;
